import { createAsyncThunk } from '@reduxjs/toolkit'

import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'
import pageApis from 'api/ApiActions/Reporting/Overview/PageActions'

export const fetchPages: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('pages/fetchPages', async (_obj, { rejectWithValue }) => {
  try {
    const response = await pageApis.getPages()

    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})
